import React from "react"

const BlogBg = () => {
  
  return (
    <div className="banner__background-wrap z-index-minus">
      <div
        className="background"
        style={{ backgroundImage: "url(/assets/img/bg/gradient_bg01.png" }}
      ></div>
    </div>
  )
}

export default BlogBg
